import { TrackedMain } from '@objectiv/tracker-react';

import { useCssViewHeight } from '~hooks/useCssViewHeight';
import { ErrorBoundary } from '../ErrorBoundary';
import { Header } from '../Header';
import { Footer } from '../Footer';

import type { HeaderCta, UspBarContent } from '~models/contentful';

type LayoutProps = {
  headerCta?: HeaderCta;
  uspBarContent?: UspBarContent;
  children: React.ReactNode;
};

export const Layout: React.FC<LayoutProps> = ({ children, uspBarContent, headerCta }) => {
  useCssViewHeight();

  return (
    <ErrorBoundary>
      <Header uspBarContent={uspBarContent} headerCta={headerCta} />
      <TrackedMain
        objectiv={{ id: 'main' }}
        style={{ '--USPBarHeight': uspBarContent ? '32px' : '0px' } as React.CSSProperties}
      >
        {children}
      </TrackedMain>
      <Footer />
    </ErrorBoundary>
  );
};
